module.exports = __webpack_public_path__ + "assets/img/index1.e34914b8.png";